import React, { useContext, useEffect, useState } from 'react'
import { Accordion, Card } from 'react-bootstrap';
import ConnUrls from '../../../../MyConns/Connections/ConnectURL';
import { HomePContext } from '../../../MyContexts/HomeP_Context';
import ImgAndTxtAndLnkCARD from '../../../MySections/DTechComps/ImgAndTxtAndLnkCARD';

const TabHPTopSliders = (props) => {
    const [homeP, setHomeP] = useContext(HomePContext);

    const [mainTitle, setMainTitle] = useState(homeP.mainTitle);
    const [webSiteLogo, setWebSiteLogo] = useState(homeP.webSiteLogo);
    const [topImages, setTopImages] = useState(homeP.topImages);
    const [loginTopImages, setLoginTopImages] = useState(homeP.loginTopImages);
    const [bootomBaners, setBootomBaners] = useState(homeP.bootomBaners);

    const [mainGallDisp, setMainGallDisp] = useState();


    useEffect(() => {


    }, [])

    useEffect(() => {


    }, [topImages])

    const setTheTopImages = (urlsList) => {
        homeP["topImages"] = urlsList;
        setTopImages(urlsList);
    }


    return (
        <>
            <div className={"col-md-12 mb-2"}>

                <div className={"col-md-12 mb-2"}>
                    <ImgAndTxtAndLnkCARD Head={"גלרייה עליונה"}
                        tblHeads={["מיקום", "תמונה", "תמונה מובייל", "טקסט על התמונה", "קישור", "מחק"]}
                        TheList={topImages}
                        theFunction={(lst) => setTheTopImages(lst)}
                        eventKey={"elme_0"} />

                </div>

            </div>

        </>

    );
}

export default TabHPTopSliders;